import { http } from '@/http/axios.js'
export function getQiniuToken() {
  return http({
    url: `/api/company/file/getUploadConf`,
    method: 'get'
  })
}
